import { createAuthenticatedAxios } from "./axiosClient"
import { getServicesBaseUrl } from "./apiEnv"

const serviciosV2Client = createAuthenticatedAxios(process.env.REACT_APP_SERVICES_URL)

// baseURL dinámico: permite alternar entre Producción y QA en runtime.
// Solo afecta a este cliente de analítica; el admin/auth sigue en prod.
serviciosV2Client.interceptors.request.use((config) => {
  config.baseURL = getServicesBaseUrl()
  return config
})

export default serviciosV2Client
